<template>
  <a-layout class="login" @click="closeQrcode">
    <a-layout-header>
      <img src="../assets/logo.png" alt="logo">
    </a-layout-header>
    <a-layout-content>
      <div class="login-dialog">
        <div class="login-card">
          <div class="card-title">腾讯云·沃云T·即速小程序 联合解决方案</div>
          <div class="card-name">快速录单系统</div>
          <div class="bold-line"></div>
        </div>
        <div class="login-formBox">
          <div class="login-form-header">登录</div>
          <a-form class="login-form">
            <div class="login-form-item">
              <input
                v-model.number="loginData.phone"
                class="login-phone"
                type="text"
                placeholder="手机号"
              >
            </div>
            <div class="login-form-item">
              <input
                v-model.number="loginData.sms_code"
                class="login-code"
                type="text"
                placeholder="验证码"
              >
              <span v-if="!timer" class="login-get-code" @click="getSmsCode">获取验证码</span>
              <span v-else class="login-sms-down">{{sms}}秒后重发</span>
            </div>
            <a-button class="login-btn" type="primary" block @click="login">登录</a-button>
          </a-form>
          <div class="login-form-footer"></div>
        </div>
      </div>
    </a-layout-content>
  </a-layout>
</template>
<script>
export default {
  data() {
    return {
      timer: false,
      sms: 60,
      loginData: {
        phone: "",
        sms_code: ""
      },
      showQrcode: false
    };
  },
  created() {
    if (this.$cookie.get("is_login")) {
      this.$router.push("home");
    }
  },
  mounted() {},
  methods: {
    login() {
      let _this = this,
        params = this.loginData;
      if (!params.phone) {
        this.$message.error("请输入手机号");
        return;
      } else if (!params.sms_code) {
        this.$message.error("请输入验证码");
        return;
      }
      axios({
        method: "POST",
        url: "/api/workOrder/login",
        data: params
      }).then(res => {
        let data = res.data;
        if (data.status == 0) {
          this.$cookie.set("is_login", this.loginData.phone, 1);
          this.$router.push("home");
        } else if (data.status == 3) {
          let url = require("../assets/xcx_qrcode.jpg");
          this.$message.warning(
            <div>
              <div>{data.data}</div>
              <img style="width:200px" src={url} alt="小程序二维码" />
            </div>,
            0
          );
          this.showQrcode = true;
        }
      });
    },
    closeQrcode() {
      if (this.showQrcode) {
        this.$message.destroy();
      }
    },
    getSmsCode() {
      let phone = this.loginData.phone;
      if (!phone) {
        this.$message.error("请输入手机号");
        return;
      }
      axios({
        method: "POST",
        url: "/api/workOrder/sendPhoneCode",
        data: {
          phone: phone
        }
      }).then(res => {
        if (res.data.status == 0) {
          this.newItmer();
        }
      });
    },
    newItmer() {
      if (!this.timer) {
        this.sms = 60;
        this.timer = setInterval(() => {
          this.sms--;
          if (this.sms <= 0) {
            clearInterval(this.timer);
            this.timer = false;
          }
        }, 1000);
      }
    }
  }
};
</script>
<style scoped>
.login {
  height: 100vh;
  background: #f5f6fa;
}
.login .ant-layout-header {
  background: #f5f6fa;
  margin-top: 0;
}
.login .ant-layout-content {
  height: 100%;
  display: flex;
  justify-content: center;
  align-items: center;
}
.login-dialog {
  width: 965px;
  height: 560px;
  display: flex;
  border-radius: 8px;
  overflow: hidden;
}
.login-card {
  height: 100%;
  width: 440px;
  background: url("../assets/login-card.png") no-repeat;
  background-size: contain;
  padding-left: 34px;
  color: #fff;
}
.card-title {
  font-size: 24px;
  margin-top: 166px;
  letter-spacing: 0.1em;
  line-height: 34px;
  width: 300px;
}
.card-name {
  font-size: 14px;
  line-height: 32px;
  margin-top: 50px;
  margin-bottom: 8px;
}
.bold-line {
  width: 40px;
  height: 4px;
  background: rgba(255, 255, 255, 1);
  border-radius: 2px;
}
.login-formBox {
  flex-wrap: wrap;
  background: #ffffff;
  width: 525px;
}
.login-form-header {
  display: flex;
  justify-content: center;
  font-size: 34px;
  color: #3091f2;
  font-weight: bold;
  margin-top: 80px;
  width: 100%;
}
.login-form {
  text-align: center;
  margin-top: 28px;
  padding: 0 98px;
}
.login-form-item {
  height: 42px;
  display: flex;
  align-items: center;
  border-bottom: 1px solid #d9d9d9;
  margin-top: 36px;
}
.login-form-item input {
  border: none;
  outline: none;
  width: 100%;
}
.login-form-item .login-code {
  width: calc(100% - 90px);
}
.login-form-title {
  width: 50px;
}
.login-get-code {
  padding: 10px;
  font-size: 14px;
  color: #3091f2;
  cursor: pointer;
}
.login-btn {
  margin-top: 50px;
  border-radius: 20px;
  height: 40px;
}
</style>
